import normalizeString from '../../util/StringUtil'

var AvFilterManager = function(filters, data, filteredData){
	this.filters = filters;
	this.data = data;
	this.filteredData = filteredData;
};

AvFilterManager.prototype.apply = function() {
	this.filteredData.splice(0, this.filteredData.length);

	var _filters = this.filters;
	var _filteredData = this.filteredData;

	this.data.forEach(function(item){
		var fail = false;
		_filters.forEach(function(filter){
			if (!filter.isActive()){
				return;
			}
			switch (filter.type){
				case "basicFilter": // fall through
				case "dateFilter":
					if (!filter.match(item)){
						fail = true;
						return;
					}
					break;
				case "singleButtonFilter":
					if (filter.selected){
						if (!filter.match(item)){
							fail = true;
							return;
						}
					}
					break;
				case "buttonFilter":
					if (filter.selection.length){
						if (!filter.match(item)){
							fail = true;
							return;
						}
					}
					break;
				case "textFilter":
					if (filter.textFilter != null && "" != filter.textFilter){
						var normalizedFilter = normalizeString(filter.textFilter.toLowerCase());
						var keys = filter.getMatchKeys(item);
						if (keys == null || keys.length == 0) return;
						fail = !keys.find(function(key){
							var normalizedKey = normalizeString(key.toLowerCase());
							return normalizedKey.includes(normalizedFilter);
						});
					}
					break;
			}
		});

		if (fail){
			return;
		}
		_filteredData.push(item);
	});
};

export default AvFilterManager